import { RichText } from '../../../atoms/RichText'
import React, { FC, ReactElement, ReactNode, isValidElement } from 'react'

interface Props {
    message: ReactNode
    tag?: keyof HTMLElementTagNameMap
    classes?: string
}
/**
 * When message is a react element (like DictionaryText) it just renders the DictionaryText
 * if it is a string, it renders it as a RichtText String
 */
export const renderMessage: FC<Props> = ({ message, tag, classes }): ReactElement => {
    const isElement = isValidElement(message)
    return isElement ? (
        message
    ) : typeof message === 'string' ? (
        <RichText tag={tag} rawHtml={message} className={classes} />
    ) : (
        <></>
    )
}
